import { GET_KOATUU } from "../types";

const initialState = {
  koatuu: [],
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_KOATUU:
      return {
        ...state,
        koatuu: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
